module.exports = __webpack_public_path__ + "img/type1_uncheck1.6ff26f4b.png";